export enum enPaymentMethod {
  MASTERCARD = 'mastercard',
  VISA = 'visa',
  AMEX = 'amex',
  ELO = 'elo',
  DINERS = 'diners',
  HIPER = 'hipercard',
  OTHER = 'other',
  PAYPAL = 'paypal',
  BOLETO = 'boleto',
  FREE = 'free',
  ONE_CLICK_BUY = 'oneClick'
}

export enum enNormalizedPaymentType {
  PAYPAL = 'paypal',
  BANKSLIP = 'bankslip',
  FREE = 'free',
  ONE_CLICK = 'oneClick',
  CREDIT_CARD = 'creditCard'
}
